import React, { ChangeEvent } from "react";
import { GridFilterCellProps } from "@progress/kendo-react-grid";

export const ContainsOnlyFilterCell: React.FC<GridFilterCellProps> = (props) => {
    const {value, onChange, } = props;

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        onChange?.({
            value: e.target.value,
            operator: "contains",     
            syntheticEvent: e
        });
    };

    return (
        <input
            className="k-textbox"
            value={value ?? ""}
            onChange={handleChange}
            style={{ width: "100%" }}
        />
    );
};
